import { type SearchBlockedUsersQuery } from '@exam-center/graphql';
import { getBlockedRecordByActiveType } from '@exam-center/utils';

import { type PickRawBlockedRecordBlockedType } from '../../constants';

import { type BlockedUserListItem } from './columns';

type BlockedUser = SearchBlockedUsersQuery['ecSearchBlockedUsers']['blockedUsers'][number];

export function mapBlockedUsersListData(blockedUser: BlockedUser): BlockedUserListItem {
  const { activeRecords } = getBlockedRecordByActiveType(blockedUser.blockedRecords);

  const blockedTypes = Array.from(new Set(activeRecords.map((record) => record.blockedType)));

  const examCenterCodes = Array.from(
    new Set(
      activeRecords
        .map((record) => record.examCenterCode)
        .filter((code): code is string => code !== null),
    ),
  );

  return {
    id: blockedUser.id,
    nameTitle: blockedUser.title,
    firstName: blockedUser.firstName,
    middleName: blockedUser.middleName,
    lastName: blockedUser.lastName,
    idCard: blockedUser.idNumber,
    blockedTypes: blockedTypes as PickRawBlockedRecordBlockedType[],
    examCenterCodes,
  };
}
